import { render, staticRenderFns } from "./CrudRegionalNucleusHealth-comp.vue?vue&type=template&id=062f2ad6&scoped=true&"
import script from "./CrudRegionalNucleusHealth-comp.vue?vue&type=script&lang=js&"
export * from "./CrudRegionalNucleusHealth-comp.vue?vue&type=script&lang=js&"
import style0 from "./CrudRegionalNucleusHealth-comp.vue?vue&type=style&index=0&id=062f2ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f2ad6",
  null
  
)

export default component.exports